import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/DailyMarketSummary/constants/copy";
const I18n = I18nUtil.createScoped(Translations);
export const DAILY_MARKET_COPY = {
  eyebrow: I18n.t("Daily market summary"),
  asOfToday: I18n.t("Today"),
  askEd: I18n.t("Ask Ed"),
  loading: I18n.t("Loading daily market summary..."),
  emptyState: I18n.t("Today's summary isn't ready yet."),
  personalTitle: I18n.t("Your daily market report"),
  generatingPill: I18n.t("Ed is generating your daily market report..."),
  personalStreamError: I18n.t(
    "Ed couldn't generate your personal market report. Please try again later.",
  ),
  connectedSheet: {
    title: I18n.t("Accounts in. Ed's reading."),
    description: I18n.t(
      "From tomorrow, this brief is built around what you actually own — your accounts, your moves, what they mean.",
    ),
    cta: I18n.t("Got it"),
  },
  needInvestPopup: {
    title: I18n.t("Connected, but I need an invest account"),
    description: I18n.t(
      "Link a brokerage, 401(k) or crypto wallet and tomorrow's summary starts from yours.",
    ),
    primaryCta: I18n.t("Connect an invest account"),
    secondaryCta: I18n.t("Not now"),
  },
} as const;
